import { render } from "./iconLineasDerecha.vue?vue&type=template&id=4b669e7a&scoped=true"
import script from "./iconLineasDerecha.vue?vue&type=script&lang=js"
export * from "./iconLineasDerecha.vue?vue&type=script&lang=js"

import "./iconLineasDerecha.vue?vue&type=style&index=0&id=4b669e7a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b669e7a"

export default script